export class AttributeDTO {
  Id: number;
  Value: string;
  TypToken: string;
}
